import { Platform } from "react-native";
import { registerEnforcementAdapter } from "./adapters/enforcementAdapter.js";
import { androidEnforcementAdapter } from "./adapters/androidEnforcementAdapter.js";

let registered = false;

/** Register Android plan executor once at app startup (no-op on web/iOS). */
export function bootstrapLockboxEnforcement() {
  if (registered) return;
  if (Platform.OS !== "android") return;
  registerEnforcementAdapter(androidEnforcementAdapter);
  registered = true;
}
